import Layout from '@/layout';
import { roterPre } from '@/settings';
var settingRouter = {
  path: "".concat(roterPre, "/setting"),
  name: 'system_group',
  meta: {
    icon: 'dashboard',
    title: '权限管理'
  },
  component: Layout,
  children: [{
    path: 'systemRole',
    name: 'setting_role',
    meta: {
      title: '角色管理'
    },
    component: function component() {
      return import('@/views/setting/systemRole/index');
    }
  }, {
    path: 'systemAdmin',
    name: 'setting_systemAdmin',
    meta: {
      title: '管理员管理'
    },
    component: function component() {
      return import('@/views/setting/systemAdmin/index');
    }
  }, {
    path: 'systemLog',
    name: 'setting_systemLog',
    meta: {
      title: '操作日志'
    },
    component: function component() {
      return import('@/views/setting/systemLog/index');
    }
  }, {
    path: 'printer/list',
    name: 'PrinterList',
    meta: {
      title: '打印机配置'
    },
    component: function component() {
      return import('@/views/setting/printer/index');
    }
  }, {
    path: 'printer/content',
    name: 'PrinterContent',
    meta: {
      title: '小票配置',
      activeMenu: "".concat(roterPre, "/setting/printer/list")
    },
    component: function component() {
      return import('@/views/setting/printer/content');
    }
  }]
};
export default settingRouter;